import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { InviteToApply } from '@shared/models/invite-to-apply';
import { ApiService } from '@shared/services';

@Injectable({ providedIn: 'root' })
export class InviteToApplyService extends ApiService<InviteToApply> {

  constructor(http: HttpClient) {
    super(http);
    this.url = 'invite-to-apply';
  }
}
